import { render, staticRenderFns } from "./DomicilioDataRegister.vue?vue&type=template&id=b85f46e2"
import script from "./DomicilioDataRegister.vue?vue&type=script&lang=js"
export * from "./DomicilioDataRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports